var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.handleClickAway),expression:"handleClickAway"}],staticClass:"sidebar-wrapper md:z-50 z-40",class:{
    'opened': _vm.open,
    'left-0 position-left': _vm.position === 'left',
    'right-0 position-right': _vm.position === 'right'
    }},[_vm._t("sidebar-heading",function(){return [(_vm.heading)?_c('h1',{staticClass:"heading-1"},[_vm._v(_vm._s(_vm.heading))]):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"w-full h-full"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }